import React from "react";
import * as Redux from 'react-redux';

import TopMenu from './TopMenu'

export class OpenTo extends React.Component {
	state = {isFailure: false};

	componentDidMount() {
		const {dispatch} = this.props;

      const params = new URLSearchParams(this.props.location.search); 
		const to = params.get('to');
      
		switch(to) {
			default:
            if (to.indexOf("profile/unsubscribe/lead/") > -1) {
               window.location.href = process.env.REACT_APP_YGL_LEGACY_APP_DOMAIN + to;
            }
				break;
		}
	}

	render() {
		var {isFailure} = this.state;
		document.title = "Redirecting...";

		return (
			<div>
				<TopMenu />
				{
					!isFailure
						? <div><i className="fa fa-spinner fa-spin"></i> Redirecting...</div>
						: <div>Redirect failed.</div>
				}
			</div>
		);
	}
}

export default Redux.connect(
	(state) => {
		return state;
	}
)(OpenTo);


// WEBPACK FOOTER //
// ./src/components/OpenTo.js